var typography = {
  heading: {
    h0: {
      fontSize: [48, 88],
      lineHeight: [52, 80],
      letterSpacing: [-1, -4]
    },
    h1: {
      fontSize: [40, 64],
      lineHeight: [44, 68],
      letterSpacing: [-0.5, -2]
    },
    h2: {
      fontSize: [32, 48],
      lineHeight: [38, 56],
      letterSpacing: [-0.5, -1]
    },
    h3: {
      fontSize: [24, 32],
      lineHeight: [30, 38],
      letterSpacing: [-0.5]
    },
    h4: {
      fontSize: 24,
      lineHeight: 28,
      letterSpacing: -0.5
    }
  },
  paragraphs: {
    p0: {
      fontWeight: 400,
      fontSize: [18, 24],
      lineHeight: [24, 32]
    },
    p1: {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: 24
    },
    p1medium: {
      fontWeight: 500,
      fontSize: 18,
      lineHeight: 24
    },
    p2: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: 20
    }
  },
  lists: {
    unordered: {
      "default": {
        marginBottom: 24,
        li: {
          marginBottom: 16,
          paddingLeft: 32,
          '&:last-child': {
            marginBottom: 0
          }
        }
      }
    },
    ordered: {
      "default": {
        marginBottom: 24,
        li: {
          marginBottom: 16,
          paddingLeft: 32,
          '&:last-child': {
            marginBottom: 0
          }
        }
      }
    }
  }
};
export default typography;